const CloseIcon = ({
  size = 11,
  color = "#FF0000",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M9.84375 8.8125C10.1562 9.09375 10.1562 9.5625 9.84375 9.84375C9.5625 10.1562 9.09375 10.1562 8.8125 9.84375L5.09375 6.125L1.34375 9.84375C1.0625 10.1562 0.59375 10.1562 0.3125 9.84375C0 9.5625 0 9.09375 0.3125 8.8125L4.03125 5.0625L0.3125 1.34375C0 1.0625 0 0.59375 0.3125 0.3125C0.59375 0 1.0625 0 1.34375 0.3125L5.09375 4.03125L8.8125 0.3125C9.09375 0 9.5625 0 9.84375 0.3125C10.1562 0.59375 10.1562 1.0625 9.84375 1.34375L6.125 5.0625L9.84375 8.8125Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
